import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GamecardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGamecardPlans } from "../../../../features/auth/store/gamecardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Gamecard from "./Gamecard";
import { fetchGamecardCategories } from "../../../../features/auth/store/gamecardCategorySlice";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

const GamecardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedGamecardPlan, setSelectedGamecardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { gamecardPlans, loading, error } = useSelector(
    (state: RootState) => state.gamecardPlans,
  );
  const { gamecardCategories } = useSelector(
    (state: RootState) => state.gamecardCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!gamecardCategories || gamecardCategories.length == 0) {
      dispatch(fetchGamecardCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchGamecardPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchGamecardPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleGamecardPlanClick = (dataPlan: Product) => {
    setSelectedGamecardPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGamecardPlan(null);
  };

  if (showDetailView && selectedGamecardPlan) {
    return (
      <GamecardDetailView
        gamecardPlan={{
          ...selectedGamecardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Gamecard
      gamecardPlans={gamecardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGamecardPlanClick={handleGamecardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default GamecardRouter;
